import {
  Typography,
  Stack,
  Box,
  IconButton,
  Skeleton,
  Alert,
} from '@mui/material'
import { Edit } from '@mui/icons-material'
import { Borrower } from '@/types'
import { formatTaxId } from '@/helpers'

type TBorrowerDetailsCardProps = {
  borrower: Borrower
  onEdit: () => void
  loading?: boolean
}

export function BorrowerDetailsCard({
  borrower,
  onEdit,
  loading = true,
}: TBorrowerDetailsCardProps) {
  return (
    <Alert
      severity="info"
      icon={false}
      action={
        <IconButton onClick={onEdit}>
          <Edit />
        </IconButton>
      }
      sx={{
        '& .MuiAlert-message': {
          width: '100%',
        },
      }}
    >
      <Box sx={{ width: '100%' }}>
        {loading ? (
          <>
            <Skeleton variant="text" width={200} height={40} />
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="text" width={120} height={24} />
            <Skeleton variant="text" width={220} height={24} />
          </>
        ) : (
          <>
            <Typography variant="h5" color="primary" gutterBottom>
              {borrower.name}
            </Typography>

            <Stack>
              <Typography fontWeight="bold">
                {borrower.tax_id_type === 'cpf' ? 'CPF' : 'CNPJ'}:{' '}
                <Typography component="span" fontWeight="regular">
                  {formatTaxId(borrower.tax_id)}
                </Typography>
              </Typography>

              {borrower.email && (
                <Typography fontWeight="bold">
                  E-mail:{' '}
                  <Typography component="span" fontWeight="regular">
                    {borrower.email}
                  </Typography>
                </Typography>
              )}

              {borrower.phone && (
                <Typography fontWeight="bold">
                  Telefone:{' '}
                  <Typography component="span" fontWeight="regular">
                    {borrower.phone}
                  </Typography>
                </Typography>
              )}

              {borrower.address && (
                <Typography>
                  <b>Endereço</b>: {borrower.address.street},{' '}
                  {borrower.address.number}
                  {borrower.address.complement &&
                    ` - ${borrower.address.complement}`}
                  {borrower.address.district &&
                    ` - ${borrower.address.district}`}
                  {borrower.address.state_code &&
                    `, ${borrower.address.state_code}`}
                  {borrower.address.zip_code &&
                    ` - ${borrower.address.zip_code}`}
                </Typography>
              )}
            </Stack>
          </>
        )}
      </Box>
    </Alert>
  )
}
